import { FilterType, Filter, FilterKey } from 'types';
import { IGetFilterGroupsProps } from '../../types';
import { hasPerm, P } from '@/utilities/roles/permissions';
import { UserRole } from '@/store/auth/types';

const noneImmigration = 'None';

const getImmigrationProviderOptions = (uniImmigrationProviders: string[]) => {
  const uniImmigrationOptions = uniImmigrationProviders.map(provider => ({
    label: provider,
    value: provider,
  }));
  return [
    ...uniImmigrationOptions,
    {
      label: 'None',
      value: noneImmigration,
    },
  ];
};

const key = FilterKey.IMMIGRATION_PROVIDERS;
export const getImmigrationProvidersFilter = ({
  activeFilters,
  userRole,
  filterOptions,
}: IGetFilterGroupsProps): Filter | null => {
  const canFilterImmProv = hasPerm(userRole || UserRole.Unknown, P.FILTER_IMM_PROV);
  const immigrationProvidersOptions = filterOptions?.immigrationProvider || [];
  if (!canFilterImmProv) {
    return null;
  }

  const parsedOptions = getImmigrationProviderOptions(immigrationProvidersOptions);

  const filters = activeFilters[key] ?? [];
  const options = parsedOptions.map(({ label, value }) => {
    return {
      label,
      value,
      checked: filters.some(filter => filter === value),
    };
  });
  return {
    name: 'Immigration providers',
    key,
    type: FilterType.SELECT_MANY,
    showSearch: true,
    options: {
      SELECT_MANY: options,
    },
  };
};
